import {useQuery} from '@apollo/react-hooks';
import {NetworkStatus} from 'apollo-client';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {LimitedType} from 'nutshell-graphql-types';
import type {
    GetLimits as GetLimitsQuery,
    GetLimitsVariables as GetLimitsQueryVariables,
} from 'nutshell-graphql-types';

import GET_LIMITS from './graphql/queries/get-limits.graphql';

export const useGetLimitsByType = (type?: LimitedType | null, shouldSkip?: boolean) => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
        networkStatus,
    } = useQuery<GetLimitsQuery, GetLimitsQueryVariables>(GET_LIMITS, {
        // @ts-expect-error
        variables: {type},
        fetchPolicy: 'cache-first',
        skip: shouldSkip || !type,
        notifyOnNetworkStatusChange: true,
    });

    const limits = data ? data.limits : null;

    return {
        isLoading,
        limits,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
        isRefetching: networkStatus === NetworkStatus.refetch,
    };
};
